/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/
import { css, FlattenSimpleInterpolation } from 'styled-components';

import { UiBreakpoint } from '../../utils/constants';

const PageCardStyles = (): FlattenSimpleInterpolation => css`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  > .gz-card__content {
    align-items: center;
    justify-content: center;
  }

  .top-image {
    width: 92px;
    margin: 12px auto 0 auto;
    display: flex;
    margin-bottom: 16px;

    &--logo {
      width: 150px;
    }
  }

  h1 {
    margin-bottom: 24px;
    text-align: center;
  }

  p {
    text-align: center;
  }

  .cta-button {
    margin-top: 24px;
  }

  @media (max-width: ${UiBreakpoint}px) {
    background-color: transparent;
    box-shadow: none;

    .cta-button {
      width: 100%;
    }
    .gz-card__content {
      padding: 0;
    }
  }
`;

export default PageCardStyles;
